/*
 * File: loadingAuth.tsx
 * Project: meki
 * File Created: Tuesday, 27th October 2020 5:27:41 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Monday, 9th January 2023 3:30:53 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/system';
import { Palette } from '@mui/material';

const ContentDiv = styled('div')(({ theme }) => ({
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100dvh',
  position: 'fixed',
  background: ' rgba(0,0,0,0.6)',
  zIndex: 9999999,
  top: 0,
  right: 0,
  left: 0,
  color: (theme.palette as Palette).primary.dark,
}));

export function LoadingAuthProgress() {
  return (
    <ContentDiv>
      <CircularProgress />
    </ContentDiv>
  );
}
